let hne_modal = jQuery('#hne-modal');
let hne_modal_content = jQuery('#hne-modal-content');

jQuery( document ).ready(function($) {


    hne_modal.on('click', function (e) {
        if (e.target === this) {
            hne_close_modal();
        }
    });

    jQuery(document).on('keydown', function(event) {
        if (event.keyCode === 27) {
            hne_close_modal();
        }
    });
});

function hne_show_modal() {
    hne_modal.show( 'slow' );

    if (window.innerWidth < 768) {
        hne_modal_content.css({
            'width'   : '100vw',
            'height'  : '100vh',
            'padding' : '0',
            'overflow': 'auto'
        });
    } else {
        hne_modal_content.css({
            'width'   : '90vw',
            'height'  : '90vh',
            'padding' : '0',
            'overflow': 'hidden'
        });
    }
    hne_set_element_to_loading(hne_modal_content);

    jQuery('.close-button').on('click', function () {
        hne_close_modal();
    });
}

/**
 * Closes the currently open modal by clearing its content, hiding it with an animation effect,
 * and removing the "modal-on" class from the body element.
 *
 * @return {void} This function does not return any value.
 */
function hne_close_modal() {
    hne_modal_content.html('');
    hne_modal.hide( 'slow' );
    jQuery('body').removeClass("modal-on");
}

/**
 * Sets the HTML content of the specified element to a loading indicator.
 * @param element
 */
function hne_set_element_to_loading(element) {
    element.html(`<div class="loading">
        <div>
            <img src="/wp-includes/images/spinner.gif"
                 alt="Spinning graphic representing that content is being loaded."/>
            <span>Loading...</span>
    `);
}